import { MotionConfig } from "framer-motion";

/**
 * Respects the OS "Reduce motion" accessibility setting. When a user has it on,
 * Framer swaps transform/layout animations for gentle fades (keeping content
 * legible). For everyone else (the default), behaviour is unchanged.
 */
export function MotionProvider({ children }: { children: React.ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
